import React, { Component, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { DrugScreenCollection } from "./DrugScreenCollection";
import { DrugScreenRapidPanel } from "./DrugScreenRapidPanel";
import ChartsFields from "../ChartsFields";
import SectionBasedDetails from "../SectionBasedDetails";
import { isSet, toQueryString, convertUnderScoreStrings, encryptString, formatPhoneNumberUS } from "../../../../../../utils/commonUtils";
import { XrayPanel } from "./XrayPanel";
import { ScreeningBoxLifting } from "./ScreeningBoxLifting";
import { ScreeningPulmonary } from "./ScreeningPulmonary";
import { ScreeningLadderClimb } from "./ScreeningLadderClimb";
import { ScreeningBloodPressure } from "./ScreeningBloodPressure";
import { ScreeningHearing } from "./ScreeningHearing";
import { ScreeningVision } from "./ScreeningVision";
import { ScreeningHA } from "./ScreeningHA";
import { ScreeningHW } from "./ScreeningHw";
import { ScreeningVF } from "./ScreningVF";
import { Spirometry } from "./Spirometry";
import { ScreeningBAT } from "./ScreeningBAT";
import { ScreeningUrinalysis } from "./ScreeningUrinalysis";
import { VisionScreenTest } from "./VisionScreenTest";
import { MinimalExam } from "./MinimalExam";
import Wrap from "../../../../../../hoc/Wrap";
import Buttons from "../../../../../../components/UI/Buttons";
import { NonDOTExamBPVisionAudio } from "./NonDOTExamBPVisionAudio";
import { ScreeningVP } from "./ScreeningVP";
import {  RespiratorFitTest } from "./RespiratorFitTest";
import { Laboratory } from "./Laboratory";
import { PulmonaryFunction } from "./PulmonaryFunction";
import { LaboratoryNew } from "./LaboratoryNew";
import LabOrderdService from "../../../../../../services/LabOrderdService";
import { Vaccination } from "./Vaccination";
import { Injection } from "./Injection";
import { DispensedRx } from "./DispensedRx";
import PERMISSIONS from "../../../../../../utils/AclPermissions";
import Acl from "../../../../../../hoc/Acl";
import { RADIOLOGY_CHOICE } from "../../../../../../utils/constant";
import { getLookupByKey } from "../../../../../../utils/commonUtils";
import LookupService from "../../../../../../services/LookupService";

import { ScreeningTbskinTest } from "./ScreeningTbskinTest";

import SendQuestionnairePopup from "../../../../../../components/Modal/SendQuestionnairePopup";
import SendTaskModal from "../../../../../../components/Modal/SendTaskModal";
import PhoneIcon from "../../../../../../components/UI/Icons/PhoneIcon";
import withReduxState from "../../../../../../hoc/wReduxState";
import Button from "../../../../../../components/UI/Buttons/Button";
import { IshiharaPlates } from "./IshiharaPlates";
import { NonDOTExamHearingAudio } from "./NonDOTExamHearingAudio";
import AddDocumentModal from "../ChartsFields/AddDocumentModal";
import { MobileHealthBundle } from "./MobileHealthBundle";
import { MobileHealthTB } from "./MobileHealthTB";
import { MobileHealthVROS } from "./MobileHealthVROS";
import Icd10Service from "../../../../../../services/Icd10Service";
import { DMEScreen } from "./DMEScreen";
import ClinicService from "../../../../../../services/ClinicService";
import { NonDOTExamBPVisionAudio1 } from "./NonDOTExamBPVisionAudio1";
import { DefaultScreen } from "./DefaultScreen";
import ImagesList from "./ImagesList";
import { NonDOTExamHearingAudio1 } from "./NonDOTExamHearingAudio1";
import { NewMinimalExam } from "./NewMinimalExam";
import PatientChartsService from "../../../../../../services/PatientChartsService";
import { NewDrugScreenRapidPanel } from "./NewDrugScreenRapidPanel";
import { NewXrayPanel } from "./NewXrayPanel";
import { VitalSigns } from "./VitalSigns";
import { Audiogram } from "./Audiogram";
import { EKG } from "./EKG";
import { TBSkinAssessment } from "./TBSkinAssessment";
import  TBBloodAssessment  from "./TBBloodAssessment";
import { ExamFitForDuty } from "./ExamFitForDuty";
import { NewVaccination } from "./NewVaccination";
import NewPatientDetails from "../../../../../../containers/EmrProviderContainer/NewUIEmrPage/NewPatientDetails";
import NewCompanyDetails from "../../../../../../containers/EmployeeVisitContainer/NewEmployeeVisitDetailView/newCompanyDetails";


const DotSubmissionPage = ({ onValidateClick, onSubmitNowClick, validation, loading, schedulerStatus, eventLogs, onSubTabChange, openSubmitModalAfterSave, onSubmitModalOpened }) => {
  const [activeSubTab, setActiveSubTab] = useState("dot-submission");
  const [showSubmitOptionsModal, setShowSubmitOptionsModal] = useState(false);
  const isDotCompleted = (schedulerStatus?.status || "").toLowerCase() === "completed";

  useEffect(() => {
    if (openSubmitModalAfterSave) {
      setShowSubmitOptionsModal(true);
      onSubmitModalOpened?.();
    }
  }, [openSubmitModalAfterSave]);
  
  const handleSubTabChange = (tab) => {
    setActiveSubTab(tab);
    if (onSubTabChange) {
      onSubTabChange(tab);
    }
  };
  const formatTimestamp = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()} ${d.getHours()}:${String(d.getMinutes()).padStart(2, '0')}`;
  };

  // Field name to user-friendly message mapping
  const getFieldErrorMessage = (fieldName) => {
    const fieldMapping = {
      'meNationalRegistryId': 'Provider DOT Registry ID is missing',
      'meFirstName': 'Provider first name is missing',
      'meLastName': 'Provider last name is missing',
      'meLicenseNumber': 'Provider license number is missing',
      'driverStreetAddress': 'Patient street address is missing',
      'driverCity': 'Patient city is missing',
      'driverState': 'Patient state is missing',
      'driverZipCode': 'Patient ZIP code is missing',
      'driverLicenseNumber': 'Patient license number is missing',
      'driverLicenseState': 'Patient license issuing state is missing',
      'clpCdlApplicantHolder': 'CLP/CDL applicant holder is required',
      'examDate': 'Exam date is required',
      'expirationDate': 'Expiration date is required',
    };

    // Check if the error message contains a field name
    if (typeof fieldName === 'string') {
      // Try to extract field name from error message like "Missing or empty required field: meNationalRegistryId"
      const fieldMatch = fieldName.match(/Missing or empty required field:\s*(\w+)/i);
      if (fieldMatch && fieldMatch[1]) {
        const field = fieldMatch[1];
        return fieldMapping[field] || fieldName;
      }
      
      // Check if the string itself is a field name
      if (fieldMapping[fieldName]) {
        return fieldMapping[fieldName];
      }
    }
    
    return fieldName;
  };

  const getValidationDescription = (validation) => {
    if (validation.success === false && validation.errors) {
      const errorCount = Object.keys(validation.errors).length;
      const totalErrors = Object.values(validation.errors).flat().length;
      return `Validation failed with ${errorCount} section${errorCount > 1 ? 's' : ''} containing ${totalErrors} error${totalErrors > 1 ? 's' : ''}`;
    }
    return validation.message || 'Validation completed successfully';
  };

  const openSubmitOptionsModal = () => {
    setShowSubmitOptionsModal(true);
  };

  const closeSubmitOptionsModal = () => {
    setShowSubmitOptionsModal(false);
  };

  const handleSubmitNow = () => {
    closeSubmitOptionsModal();
    if (onSubmitNowClick) {
      onSubmitNowClick();
    }
  };

  const handleScheduleNightlySubmission = () => {
    closeSubmitOptionsModal();
    if (onValidateClick) {
      onValidateClick();
    }
  };


  return (
    <div className="card-body sh_cardBody">
      <div className="tab-content" id="">
        <div className="tab-pane fade show active" id="screening" role="tabpanel">
          <div
            className="sh_cardBody py-0"
          style={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            minHeight: "calc(-150px + 100vh)",
          }}
        >
          <div
            className="position-relative"
            style={{
              height: "700px",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            <div
              className="d-flex"
              style={{
                flex: "1 1 0%",
                overflow: "hidden",
                minHeight: 0,
                height: "100%",
              }}
            >
              {/* Left Sidebar */}
              <div
                className="border-end w-25"
                style={{
                  width: "220px",
                  backgroundColor: "rgb(248, 249, 250)",
                  padding: 0,
                  display: "flex",
                  flexDirection: "column",
                  height: "calc(-150px + 90vh)",
                  maxHeight: "100%",
                  overflow: "hidden",
                  marginRight: "10px",
                }}
              >

                <div
                  style={{
                    flex: "1 1 0%",
                    overflowY: "auto",
                    minHeight: 0,
                  }}
                >
                  <div
                    className="menu-item"
                    data-tab="dot-submission"
                    style={{
                      padding: "8px 15px",
                      cursor: "pointer",
                      backgroundImage:
                        activeSubTab === "dot-submission"
                          ? "linear-gradient(270deg, rgb(154, 161, 255) 6.25%, rgb(68, 116, 230) 100%)"
                          : "none",
                      backgroundColor:
                        activeSubTab === "dot-submission" ? "rgb(233, 236, 239)" : "transparent",
                      color: activeSubTab === "dot-submission" ? "rgb(255, 255, 255)" : "rgb(73, 80, 87)",
                      borderLeft:
                        activeSubTab === "dot-submission"
                          ? "4px solid rgb(0, 86, 179)"
                          : "4px solid transparent",
                      transition: "0.2s",
                      position: "relative",
                      borderBottom: "1px solid rgb(233, 236, 239)",
                    }}
                    onClick={() => handleSubTabChange("dot-submission")}
                  >
                    <div className="d-flex align-items-center justify-content-between">
                      <span
                        style={{
                          fontWeight: activeSubTab === "dot-submission" ? 600 : 500,
                          fontSize: "14px",
                          flex: "1 1 0%",
                        }}
                      >
                        DOT Submission
                      </span>
                    </div>
                  </div>
                  <div
                    className="menu-item"
                    data-tab="fmcsa-response"
                    style={{
                      padding: "8px 15px",
                      cursor: "pointer",
                      backgroundImage:
                        activeSubTab === "fmcsa-response"
                          ? "linear-gradient(270deg, rgb(154, 161, 255) 6.25%, rgb(68, 116, 230) 100%)"
                          : "none",
                      backgroundColor:
                        activeSubTab === "fmcsa-response" ? "rgb(233, 236, 239)" : "transparent",
                      color:
                        activeSubTab === "fmcsa-response" ? "rgb(255, 255, 255)" : "rgb(73, 80, 87)",
                      borderLeft:
                        activeSubTab === "fmcsa-response"
                          ? "4px solid rgb(0, 86, 179)"
                          : "4px solid transparent",
                      transition: "0.2s",
                      position: "relative",
                      borderBottom: "1px solid rgb(233, 236, 239)",
                    }}
                    onClick={() => handleSubTabChange("fmcsa-response")}
                  >
                    <div className="d-flex align-items-center justify-content-between">
                      <span
                        style={{
                          fontWeight: activeSubTab === "fmcsa-response" ? 600 : 500,
                          fontSize: "14px",
                          flex: "1 1 0%",
                        }}
                      >
                        FMCSA Response
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Content Area */}
              <div
                className="flex-grow-1 w-75"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "rgb(255, 255, 255)",
                  overflow: "hidden",
                  minHeight: 0,
                }}
              >
                <div
                  className="border-bottom"
                  style={{
                    padding: "10px 20px",
                    backgroundColor: "rgb(248, 249, 250)",
                    flexShrink: 0,
                  }}
                >
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <h5
                        className="text-sm font-weight-bold mb-0"
                        style={{ color: "rgb(33, 37, 41)" }}
                        id="content-title"
                      >
                        {activeSubTab === "dot-submission" ? "DOT Submission" : activeSubTab === "fmcsa-response" ? "FMCSA Response" : "DOT Submission"}
                      </h5>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    flex: "1 1 0%",
                    height: "calc(-100px + 90vh)",
                    overflowY: "auto",
                    padding: "14px",
                  }}
                >
                  {/* DOT Submission Content */}
                  <div className="tab-content-item" id="dot-submission-content">
                    {activeSubTab === "dot-submission" && (
                      <>
                        {/* Submit to DOT action with option modal */}
                        <div className="mb-3 d-flex align-items-center justify-content-start">
                          <div>
                            <button
                              type="button"
                              className="btn btn-primary btn-sm"
                              disabled={loading || isDotCompleted}
                              onClick={openSubmitOptionsModal}
                            >
                              {loading ? "Processing DOT Submission..." : "Submit to DOT"}
                            </button>
                            {schedulerStatus?.exists && (
                              <span className={`badge ms-2 ${isDotCompleted ? 'bg-secondary' : 'bg-success'}`}>
                                {isDotCompleted ? "Completed" : "Scheduled"}
                              </span>
                            )}
                            {loading && (
                              <span className="ms-3" style={{ position: "relative" }}>
                                <span
                                  className="spinner-border spinner-border-sm text-primary"
                                  role="status"
                                  style={{ width: "16px", height: "16px" }}
                                >
                                  <span className="sr-only">Loading...</span>
                                </span>
                              </span>
                            )}
                          </div>
                        </div>
                        <Modal
                          show={showSubmitOptionsModal && !loading}
                          onHide={closeSubmitOptionsModal}
                          centered
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>Submit to DOT</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            {schedulerStatus?.exists ? (
                              <>
                                This DOT submission is already scheduled.
                                <br />
                                Do you want to submit now anyway?
                              </>
                            ) : (
                              <>Choose how you want to send this DOT submission.</>
                            )}
                          </Modal.Body>
                          <Modal.Footer>
                            <button
                              type="button"
                              className="btn btn-outline-primary"
                              onClick={handleSubmitNow}
                            >
                              Submit Now
                            </button>
                            {!schedulerStatus?.exists && (
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleScheduleNightlySubmission}
                              >
                                Schedule for Nightly Submission
                              </button>
                            )}
                          </Modal.Footer>
                        </Modal>


                        {/* Success Alert */}
                        {validation && validation.success === true && !validation.errors && (
                          <div className="alert alert-success d-flex align-items-center mt-3" role="alert">
                            <i className="fas fa-check-circle me-2" style={{ fontSize: "18px" }}></i>
                            <div>
                              <strong>Validation Successful!</strong>
                              <p className="mb-0" style={{ fontSize: "14px" }}>
                                DOT submission has been validated and scheduled successfully.
                              </p>
                            </div>
                          </div>
                        )}

                        {/* Validation Errors */}
                        {validation && (validation.success === false || !validation.success) && validation.errors && 
                         Object.keys(validation.errors).length > 0 && (
                          <div
                            className="alert alert-danger mb-0 mt-3"
                            style={{ whiteSpace: "pre-line" }}
                          >
                            <ul className="mb-0 pl-0">
                              <strong>Validation Errors:</strong>
                              <br />
                              {Object.entries(validation.errors).map(
                                ([section, msgs], idx) => {
                                  // Handle both array and object formats
                                  const errorList = Array.isArray(msgs) ? msgs : (msgs ? [msgs] : []);
                                  
                                  return errorList.map((m, i2) => {
                                    const errorMessage = typeof m === 'string' ? m : (m.message || m.field || JSON.stringify(m));
                                    const friendlyMessage = getFieldErrorMessage(errorMessage);
                                    return (
                                      <li key={`${idx}-${i2}`}>{friendlyMessage}</li>
                                    );
                                  });
                                }
                              )}
                            </ul>
                          </div>
                        )}
                      </>
                    )}

                    {activeSubTab === "fmcsa-response" && (
                      <div>
                        {eventLogs && eventLogs.length > 0 ? (
                          eventLogs
                            .filter((log) => log.action === 'submission')
                            .map((log, index) => {
                              // Extract response message from log data
                              const getResponseMessage = () => {
                                if (log.data) {
                                  // Check for error message
                                  if (log.data.error) {
                                    return log.data.error;
                                  }
                                  // Check for message
                                  if (log.data.message) {
                                    return log.data.message;
                                  }
                                  // Check for response message
                                  if (log.data.response && log.data.response.message) {
                                    return log.data.response.message;
                                  }
                                  // Check for success message
                                  if (log.data.success && log.data.message) {
                                    return log.data.message;
                                  }
                                }
                                if (log.apiResponse) {
                                  if (log.apiResponse.error) {
                                    return log.apiResponse.error;
                                  }
                                  if (log.apiResponse.message) {
                                    return log.apiResponse.message;
                                  }
                                }
                                if (log.description) {
                                  return log.description;
                                }
                                return 'No response message available';
                              };

                              return (
                                <div key={log.log_id || index} className="card mb-3 border shadow-sm" style={{ maxWidth: "100%", overflow: "hidden" }}>
                                  <div className="card-body p-3" style={{ maxWidth: "100%", overflow: "hidden" }}>
                                    <div className="d-flex justify-content-between align-items-start flex-wrap mb-3" style={{ minWidth: 0, gap: "6px" }}>
                                      <h6 className="text-sm font-weight-bold mb-0" style={{ minWidth: 0, overflowWrap: "anywhere", wordBreak: "break-word" }}>FMCSA Response</h6>
                                      <small className="text-muted ml-2" style={{ minWidth: 0, overflowWrap: "anywhere", wordBreak: "break-word" }}>
                                        <strong>Upload Time:</strong> {log.time || formatTimestamp(log.created_at)}
                                      </small>
                                    </div>
                                    
                                    <div className="mb-3">
                                      <strong>Status:</strong>{' '}
                                      <span className={`badge ${log.status === 'success' ? 'badge-success' : log.status === 'failed' ? 'badge-danger' : 'badge-warning'}`}>
                                        {log.status || 'Unknown'}
                                      </span>
                                    </div>
                                    
                                    <div style={{ maxWidth: "100%", minWidth: 0 }}>
                                      <strong>Response:</strong>
                                      <p
                                        className="mb-0 mt-2"
                                        style={{
                                          fontSize: "14px",
                                          overflowWrap: "anywhere",
                                          wordBreak: "break-word",
                                          whiteSpace: "pre-wrap",
                                          maxWidth: "100%",
                                          minWidth: 0,
                                        }}
                                      >
                                        {getResponseMessage()}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                        ) : (
                          <div className="text-center text-muted py-5">
                            <p>No FMCSA response available yet. DOT submission logs will appear here after submission.</p>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  {/* All Events Tab Content */}
                  <div className="tab-content-item d-none" id="all-events-content">
                    {/* PDF Generator Card */}
                    <div className="card mb-3 border shadow-sm">
                      <div className="card-body p-3">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <div className="d-flex align-items-start ">
                            <span className="pr-1">
                              <i className="fas fa-print text-md text-dark font-weight-bold" />
                            </span>
                            <div className="d-flex  flex-column gap-1">
                              <h6 className="text-sm font-weight-bold mb-0">
                                PDF generator
                              </h6>
                              <p className="mb-0">pdf genereted in this time </p>
                            </div>
                          </div>
                          <small className="text-muted">23.1.2026 14:30</small>
                        </div>
                        <a
                          href="#"
                          className="text-decoration-none text-primary"
                          data-bs-toggle="collapse"
                          data-bs-target="#pdfcontainer"
                          aria-expanded="false"
                          aria-controls="pdfcontainer"
                        >
                          <small>view detail</small>
                        </a>
                        <hr className="my-2" />
                        <div className="collapse " id="pdfcontainer">
                          <div
                            className="react-json-view"
                            style={{
                              fontFamily: "monospace",
                              cursor: "default",
                              backgroundColor: "rgba(0, 0, 0, 0)",
                              position: "relative",
                              overflowX: "auto",
                            }}
                          >
                            <div className="pretty-json-container object-container">
                              <div className="object-content">
                                <div className="object-key-val">
                                  <span>
                                    <span
                                      style={{
                                        display: "inline-block",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <div
                                        className="icon-container"
                                        style={{
                                          display: "inline-block",
                                          width: "17px",
                                        }}
                                      >
                                        <span className="collapsed-icon">
                                          <svg
                                            viewBox="0 0 15 15"
                                            fill="currentColor"
                                            style={{
                                              verticalAlign: "top",
                                              color: "rgb(42, 161, 152)",
                                              height: "1em",
                                              width: "1em",
                                              paddingLeft: "2px",
                                            }}
                                          >
                                            <path d="M0 14l6-6-6-6z" />
                                          </svg>
                                        </span>
                                      </div>
                                      <span />
                                      <span
                                        style={{
                                          display: "inline-block",
                                          cursor: "pointer",
                                          fontWeight: "bold",
                                          color: "rgb(0, 43, 54)",
                                        }}
                                      >
                                        {"{"}
                                      </span>
                                    </span>
                                  </span>
                                  <div
                                    className="node-ellipsis"
                                    style={{
                                      display: "inline-block",
                                      color: "rgb(203, 75, 22)",
                                      fontSize: "18px",
                                      lineHeight: "10px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    ...
                                  </div>
                                  <span className="brace-row">
                                    <span
                                      style={{
                                        display: "inline-block",
                                        cursor: "pointer",
                                        fontWeight: "bold",
                                        color: "rgb(0, 43, 54)",
                                        paddingLeft: 0,
                                      }}
                                    >
                                      {"}"}
                                    </span>
                                    <div
                                      className="object-meta-data"
                                      style={{
                                        display: "inline-block",
                                        padding: "0px 0px 0px 10px",
                                      }}
                                    />
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Mail Triggered Card */}
                    <div className="card border shadow-sm">
                      <div className="card-body p-3">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <div className="d-flex gap-1 align-items-start ">
                            <span className="pr-1">
                              <i className="fas fa-envelope text-md text-dark " />
                            </span>
                            <div className="d-flex flex-column gap-1">
                              <h6 className="text-sm font-weight-bold mb-0">
                                Mail Triggered
                              </h6>
                              <p className="mb-0">
                                mail triggerd when this is created
                              </p>
                            </div>
                          </div>
                          <small className="text-muted">21.1.2026 10:30</small>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Print Pdf Tab Content */}
                  <div
                    className="tab-content-item d-none"
                    id="print-policy-content"
                  >
                    <div className="card border shadow-sm">
                      <div className="card-body p-3">
                        <h6 className="fw-bold">Print Pdf Content</h6>
                        <p className="text-muted mb-0">
                          Content for print pdf section...
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Save & Update Tab Content */}
                  <div
                    className="tab-content-item d-none"
                    id="save-update-content"
                  >
                    <div className="card border shadow-sm">
                      <div className="card-body p-3">
                        <h6 className="fw-bold">Save &amp; Update Content</h6>
                        <p className="text-muted mb-0">
                          Content for save &amp; update section...
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Checks Tab Content */}
                  <div className="tab-content-item d-none" id="checks-content">
                    <div className="card border shadow-sm">
                      <div className="card-body p-3">
                        <h6 className="fw-bold">Checks Content</h6>
                        <p className="text-muted mb-0">
                          Content for checks section...
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Trigger Tab Content */}
                  <div className="tab-content-item d-none" id="trigger-content">
                    <div className="card border shadow-sm">
                      <div className="card-body p-3">
                        <h6 className="fw-bold">Mail Trigger Content</h6>
                        <p className="text-muted mb-0">
                          Content for trigger section...
                        </p>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

class ActivityChartsContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      charts: [],
      isLeftSidebarCollapsed: false,
      isPatientPopoverOpen: false,
      isCompanyPopoverOpen: false,
      headers:[],
      buttons:{},
      computationFunction:async ()=>{return {};},
      reasonForLabs:{},
      isDocumentModalOpen:false,
      isSendQuestionnaireOpen:false,
      activeTabId: 'patient', 
      dotValidationErrors:{},
      dotValidationLoading:false,
      dotValidation: null,
      dotEventLogs: [],
      dotSchedulerStatus: null,
      openSubmitToDotModalAfterSave: false,
      submissionJustPassed: false,
      showSendLabResultsModal: false,
      sendLabResultsOptions: {
        sendPatient: true,
        sendEmployer: true,
      },
      sendTaskModalOpen: false,
      sendTaskModalInitialTaskTitle: "",
      sendTaskModalInitialMessage: "",
      sendTaskModalNavigationLink: "",
      radiologyChoiceOptions: [{ label: "-Select-", value: "" }],
      radiologyOrderOptions: [{ label: "-Select-", value: "" }],
    };
    this.patientBtnRef = React.createRef();
    this.companyBtnRef = React.createRef();
    this.patientPopoverRef = React.createRef();
    this.companyPopoverRef = React.createRef();
  }

  openSendTaskModalFromLab = (taskTitle, message) => {
    const { employeeDetails, companyDetails, profile } = this.props;
    const employeeId = employeeDetails?.employee_id || employeeDetails?.id;
    const patientParams = encryptString({
      patientName: `${employeeDetails?.first_name || ""} ${employeeDetails?.last_name || ""}`.trim(),
      company_id: employeeDetails?.company_id || companyDetails?.company_uuid || "",
      company_assigned: employeeDetails?.company_assigned || "",
      employee_id: employeeId || "",
    });
    const visitHistoryUrl =
      profile?.role === "employer_admin"
        ? `/employer-employee/visit-history/${employeeId}/${patientParams}`
        : `/employee/visit-history/${employeeId}/${patientParams}`;

    this.setState({
      sendTaskModalOpen: true,
      sendTaskModalInitialTaskTitle: taskTitle || "",
      sendTaskModalInitialMessage: message || "",
      sendTaskModalNavigationLink: visitHistoryUrl,
    });
  };

  closeSendTaskModal = () => {
    this.setState({
      sendTaskModalOpen: false,
      sendTaskModalInitialTaskTitle: "",
      sendTaskModalInitialMessage: "",
      sendTaskModalNavigationLink: "",
    });
  };

  /**
   * `/result/workstatus?visitId=` for work status). Visit page reads `activityMappingId` and opens the chart.
   */
  openSendTaskModalFromActivityChartToolbar = () => {
    const visitId =
      this.props.visitDetails?.visit_id ||
      this.props.visitDetails?.["0"]?.visit_id ||
      null;
    const mappingId = this.props.mappingId || null;
    let path = "";
    if (typeof window !== "undefined") {
      const { pathname, search } = window.location;
      if (visitId && mappingId) {
        if (pathname.includes("/visits/emr-details/")) {
          const emrMatch = pathname.match(/^(\/visits\/emr-details\/[^/]+\/visits)/);
          const base = emrMatch
            ? emrMatch[1]
            : `/visits/emr-details/${visitId}/visits`;
          path = `${base}?activityMappingId=${encodeURIComponent(mappingId)}`;
        } else {
          path = `/visits/visit-details/${visitId}?activityMappingId=${encodeURIComponent(mappingId)}`;
        }
      } else {
        path = `${pathname}${search || ""}`;
      }
    }
    this.setState({
      sendTaskModalOpen: true,
      sendTaskModalInitialTaskTitle: "",
      sendTaskModalInitialMessage: "",
      sendTaskModalNavigationLink: path,
    });
  };

  /** Patient portal / unified questionnaire — no internal messaging from activity charts. */
  isPatientQuestionnaireContext = () =>
    !!this.props.suppressPatientPostSaveLogout ||
    !!this.props.profileDetails?.employee_login;

  componentDidMount = async()=> {
    // await this.fetchReasonForLabList();
          const { formData } = this.props;
          console.log('formDataaaaaaaaaaaa',formData);
    this.fetchIcd10List()
    this.fetchRadiologyChoiceOptions();
    this.fetchRadiologyOrderOptions();
    this.setCharts();
    const isDotProviderExam =
      (this.props.activityName === "Examination - DOT" ||
        this.props.activityName === "Exam - DOT - Department Of Transportation") &&
      this.props.type === "Provider Exam";
    if (isDotProviderExam) {
      this.setState({ activeTabId: 'history' });
      this.fetchDotSchedulerStatus();
    }
    // console.log('this.props.hasEditAccess',this.props);
     if (!this.props.hasEditAccess) {
        window.history.pushState(null, null, window.location.href);
        window.onpopstate = () => {
          window.history.go(1);
        };
      }
    document.addEventListener("mousedown", this.handleGlobalMouseDown);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleGlobalMouseDown);
  }
  isTabletWidth = () => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia("(min-width: 768px) and (max-width: 1024px)").matches;
  };
  handleGlobalMouseDown = (event) => {
    if (!this.state.isPatientPopoverOpen && !this.state.isCompanyPopoverOpen) return;
    const target = event.target;
    const clickedPatient =
      this.patientBtnRef.current?.contains(target) ||
      this.patientPopoverRef.current?.contains(target);
    const clickedCompany =
      this.companyBtnRef.current?.contains(target) ||
      this.companyPopoverRef.current?.contains(target);
    if (!clickedPatient && this.state.isPatientPopoverOpen) {
      this.setState({ isPatientPopoverOpen: false });
    }
    if (!clickedCompany && this.state.isCompanyPopoverOpen) {
      this.setState({ isCompanyPopoverOpen: false });
    }
  };
  fetchRadiologyChoiceOptions = async () => {
    try {
      const options = await getLookupByKey(RADIOLOGY_CHOICE);
      if (Array.isArray(options) && options.length > 0) {
        this.setState({ radiologyChoiceOptions: options }, () => {
          if (this.props.type === "Xray") {
            this.setCharts();
          }
        });
      }
    } catch (e) {
      console.warn("Failed to load radiology choice options:", e);
    }
  };
  fetchRadiologyOrderOptions = async () => {
    try {
      const options = await getLookupByKey('radiology_order');
      if (Array.isArray(options) && options.length > 0) {
        this.setState({ radiologyOrderOptions: options }, () => {
          if (this.props.type === "Xray") {
            this.setCharts();
          }
        });
      }
    } catch (e) {
      console.warn("Failed to load radiology order options:", e);
    }
  };
  componentDidUpdate = (prevProps)=>{
    if(prevProps.status!==this.props.status){
      this.setCharts();
    }
  }

  // componentDidUpdate(prevProps) {
  //   if (prevProps.type !== this.props.type) {
  //     this.setCharts();
  //   }
  // }
  fetchDotEventLogs = async () => {
    const { mappingId, params } = this.props;
    console.log('mappingId',mappingId);
    console.log('params',params);
    console.log('props',this.props);

    
    try {
      const logs = await PatientChartsService.getDotFormEventLogs(
        null,
        this.props.companyDetails.company_uuid,
        mappingId
      );
      this.setState({ dotEventLogs: Array.isArray(logs) ? logs : [] });
    } catch (e) {
      console.error('Error fetching DOT event logs:', e);
      this.setState({ dotEventLogs: [] });
    }
  }

  handleTabClick = (tabId) => {
    const dotTabUnlocked = this.props.formData?.dot_submission_ready || this.state.submissionJustPassed;
    if (tabId === 'dot_submission' && !dotTabUnlocked) {
      return;
    }
    this.setState({ activeTabId: tabId });
    if (tabId === 'dot_submission') {
      this.fetchDotEventLogs();
      this.fetchDotSchedulerStatus();
    }
  };

  fetchDotSchedulerStatus = async () => {
    const { params, mappingId } = this.props;
    try {
      const res = await PatientChartsService.getDotSchedulerStatus(
        null,
        params?.companyuuid,
        mappingId
      );
      const data = res?.data || res;
      this.setState({ dotSchedulerStatus: data });
    } catch (e) {
      // ignore; leave status null
    }
  }

  isDotSchedulerLocked = () => {
    const schedulerStatus = (this.state.dotSchedulerStatus?.status || "").toLowerCase();
    return schedulerStatus === "completed" || schedulerStatus === "pending";
  }

  openSendLabResultsModal = () => {
    this.setState({
      showSendLabResultsModal: true,
      sendLabResultsOptions: {
        sendPatient: true,
        sendEmployer: true,
      },
    });
  }

  closeSendLabResultsModal = () => {
    this.setState({ showSendLabResultsModal: false });
  }

  handleToggleSendLabOption = (key) => {
    this.setState((prevState) => ({
      sendLabResultsOptions: {
        ...prevState.sendLabResultsOptions,
        [key]: !prevState.sendLabResultsOptions[key],
      },
    }));
  }

  handleConfirmSendLabResults = () => {
    const { sendLabResultsOptions } = this.state;
    if (!sendLabResultsOptions.sendPatient && !sendLabResultsOptions.sendEmployer) {
      this.props.Toast?.error?.('Please select at least one option (Send Patient or Send Employer).');
      return;
    }
    if (this.props.onSendLabResults) {
      this.props.onSendLabResults(sendLabResultsOptions);
    }
    this.closeSendLabResultsModal();
  }

  getFieldErrorMessage = (fieldName) => {
    const fieldMapping = {
      meNationalRegistryId: 'Provider DOT Registry ID is missing',
      meFirstName: 'Provider first name is missing',
      meLastName: 'Provider last name is missing',
      meLicenseNumber: 'Provider license number is missing',
      driverStreetAddress: 'Patient street address is missing',
      driverCity: 'Patient city is missing',
      driverState: 'Patient state is missing',
      driverZipCode: 'Patient ZIP code is missing',
      driverLicenseNumber: 'Patient license number is missing',
      driverLicenseState: 'Patient license issuing state is missing',
      clpCdlApplicantHolder: 'CLP/CDL applicant holder is required',
      examDate: 'Exam date is required',
      expirationDate: 'Expiration date is required',
    };
    if (typeof fieldName === 'string') {
      const fieldMatch = fieldName.match(/Missing or empty required field:\s*(\w+)/i);
      if (fieldMatch && fieldMatch[1]) {
        return fieldMapping[fieldMatch[1]] || fieldName;
      }
      if (fieldMapping[fieldName]) return fieldMapping[fieldName];
    }
    return fieldName;
  }

  onSaveAndSubmitHandler = async () => {
    const { Toast, onSubmitHandler } = this.props;
    try {
      const saveResult = await onSubmitHandler(undefined, false, false, true);
      if (!saveResult?.success) return;
      this.fetchDotSchedulerStatus();
      Toast.success('Charts Updated Successfully');
      this.setState({
        openSubmitToDotModalAfterSave: true,
        activeTabId: 'dot_submission',
        submissionJustPassed: true,
      });
    } catch (err) {
      Toast.error(err?.message || 'Something went wrong! Please try again later.');
    }
  }

  handleDotNightlySubmission = async () => {
    const { Toast, mappingId, visitDetails } = this.props;
    const visitId = visitDetails?.visit_id;
    if (!visitId || !mappingId) {
      Toast.error('Missing visit or mapping details for DOT scheduling.');
      return;
    }
    this.setState({ dotValidationLoading: true });
    try {
      const res = await PatientChartsService.scheduleDotNightly(mappingId, visitId);
      const payload = res?.data ? res.data : res;
      const isSuccess = payload?.success !== false;
      if (!isSuccess) {
        const errors = payload?.errors || payload?.data?.errors;
        this.setState({ dotValidation: errors ? { success: false, errors } : null });
        Toast.error(payload?.message || 'Failed to schedule DOT submission.');
      } else {
        Toast.success('DOT submission scheduled for nightly processing.');
        this.setState({ dotValidation: null });
      }
      await this.fetchDotSchedulerStatus();
      await this.fetchDotEventLogs();
      this.setState({ activeTabId: 'dot_submission' });
    } catch (e) {
      const errData = e?.response?.data;
      const errors = errData?.errors || errData?.data?.errors;
      this.setState({ dotValidation: errors ? { success: false, errors } : null });
      Toast.error(errData?.message || e?.message || 'Failed to schedule DOT submission.');
    } finally {
      this.setState({ dotValidationLoading: false });
    }
  }

  handleDotSubmitNowSelection = async () => {
    const { Toast, mappingId, visitDetails } = this.props;
    const visitId = visitDetails?.visit_id;
    if (!visitId || !mappingId) {
      Toast.error('Missing visit or mapping details for DOT submit now.');
      return;
    }
    this.setState({ dotValidationLoading: true });
    try {
      const response = await PatientChartsService.submitDotNow(mappingId, visitId);
      const payload = response?.data ? response.data : response;
      const isSuccess = payload?.success !== false;
      if (isSuccess) {
        const status = payload?.data?.status || payload?.status || 'processed';
        Toast.success(`DOT submit now completed (${status}).`);
        this.setState({ dotValidation: null });
      } else {
        const errors = payload?.errors || payload?.data?.errors;
        this.setState({ dotValidation: errors ? { success: false, errors } : null });
        Toast.error(payload?.message || (errors ? 'Validation failed. Please check the errors below.' : 'DOT submit now failed.'));
      }
      this.fetchDotSchedulerStatus();
      this.fetchDotEventLogs();
    } catch (e) {
      const errData = e?.response?.data;
      const errors = errData?.errors || errData?.data?.errors;
      this.setState({ dotValidation: errors ? { success: false, errors } : null });
      Toast.error(errData?.message || e?.message || 'DOT submit now failed. Please try again.');
    } finally {
      this.setState({ dotValidationLoading: false });
    }
  }

  setCharts =async ()=> {
    //Drug Test - EZ-Reader
    const employmenStatusOption= await this.fetchEmplymentStatusOptions(this.props.employeeDetails.clinic_id);
    const { type,activityName} = this.props;
    let returnData = {charts:[],defaultValue:{},headerContent:<></>};
    console.log("Type",type);
    console.log("Activity Name",activityName);
    switch (type) {
      case "Drug Screen Collection":
        returnData = DrugScreenCollection({...this.props});
        break;
      case "Drug Screen - 10 Panel":
        returnData = NewDrugScreenRapidPanel({...this.props},10);
        break;
      case "Drug Screen - 10 Panel (AH)":
        returnData = NewDrugScreenRapidPanel({...this.props},10,'others','AH');
        break;
      case "Drug Screen - 11 Panel":
        returnData = NewDrugScreenRapidPanel({...this.props},11);
        break;
      case "Drug Screen - 12 Panel":
        returnData = NewDrugScreenRapidPanel({...this.props},12);
        break;
      case "Drug Screen - 13 Panel":
        returnData = NewDrugScreenRapidPanel({...this.props},13);
        break;
      case "Drug Screen - 4 Panel":
        returnData = NewDrugScreenRapidPanel({...this.props},4);
        break;
      case "Drug Screen - 5 Panel":
        returnData = NewDrugScreenRapidPanel({...this.props},5);
        break;
      case "Drug Screen - 7 Panel":
        returnData = NewDrugScreenRapidPanel({...this.props},7);
        break;
      case "Drug Screen - 9 Panel":
        returnData = NewDrugScreenRapidPanel({ ...this.props }, 9);
        break;
      case "Drug Screen - EZ-Reader": 
        returnData = NewDrugScreenRapidPanel({...this.props},13,'EZ-Reader','EZ-Reader');
        break;
       case "Xray": {
        returnData = NewXrayPanel({
          ...this.props,
          reasonForLabs: this.state.reasonForLabs,
          fetchIcd10List: this.fetchIcd10List,
          radiologyChoiceOptions: this.state.radiologyChoiceOptions,
          radiologyOrderOptions: this.state.radiologyOrderOptions,
        });
        break;
      }
      case "Screening - Box Lift":
        returnData = ScreeningBoxLifting({...this.props});
        break;
      case "Pulmonary Function":
        returnData = ScreeningPulmonary({...this.props});
        break;
       case "Pulmonary Function Test":
        returnData = PulmonaryFunction({...this.props});
        break;
      case "Vision Screen":
        returnData = VisionScreenTest({...this.props});
        break;
      case "Screening":
        returnData = activityName=='Screening - TB Skin Test'? ScreeningTbskinTest({...this.props}):ScreeningLadderClimb({...this.props});
          break;
      case "Screening - Blood Pressure":
        returnData = ScreeningBloodPressure({...this.props});
        break;
      case "Screening - Hearing":
       returnData = ScreeningHearing({...this.props});
       break;
      case "Screening - Urinalysis":
        returnData = ScreeningUrinalysis({...this.props});
        break;
      case "Screening - Vision - All Test":
        returnData = ScreeningVision({...this.props})
        break;
      case "Screening - VF":
          returnData = ScreeningVF({...this.props},'VF')
          break;
      case "Screening - VJ":
          returnData = ScreeningVF({...this.props},'VJ')
          break;
      case "Screening - VS":
          returnData = ScreeningVF({...this.props},'VS')
          break;
      case "Screening - HA":
        returnData = ScreeningHA({...this.props})
        break;
      case "Screening - HW":
        returnData = ScreeningHW({...this.props})
        break;
      case "Screening BAT":
        returnData = ScreeningBAT({...this.props});
        break;
      case "Screening - VP":
        returnData = ScreeningVP({...this.props});
        break;
      case "Ishihara - 6 Plates":
        returnData = IshiharaPlates({ ...this.props });
        break
      case "Ishihara - 14 Plates":
        returnData = IshiharaPlates({ ...this.props });
        break
      case "Spirometry":
        returnData = Spirometry({...this.props});
        break;
      case "Minimal Exam":
        returnData = NewMinimalExam({...this.props,employmenStatusOption:employmenStatusOption});
        break;
      case "Non DOT Exam - BP / Vision / Audio":
        // returnData = NonDOTExamBPVisionAudio({...this.props,employmenStatusOption:employmenStatusOption});
        returnData = NonDOTExamBPVisionAudio1({
          ...this.props,
          employmenStatusOption: employmenStatusOption,
          onSaveAndSubmit: () => { this.onSaveAndSubmitHandler(); },
        });
        break;
        case "Exam - Non DOT - Hearing Audio":
          returnData = NonDOTExamHearingAudio1({...this.props,employmenStatusOption:employmenStatusOption});
          break;
        case "TB Blood Draw":  
          returnData = TBBloodAssessment({...this.props});
          break;
        case "TB Skin Test":  
          returnData = TBSkinAssessment({...this.props});
          break;
      // case "Provider Exam":
      //   // returnData = NonDOTExamBPVisionAudio({...this.props},'ProviderExam');
      //   returnData = activityName=='Mobile Health - Bundle V/ROS Exam & TB Assessment'? MobileHealthBundle({...this.props}):activityName=='Mobile Health - TB Assessment'? MobileHealthTB({...this.props},'ProviderExam'):activityName=='Mobile Health - V/ROS Exam'? MobileHealthVROS({...this.props},'ProviderExam'):NonDOTExamBPVisionAudio1({...this.props,employmenStatusOption:employmenStatusOption},'ProviderExam');
      //     break;
      case "Provider Exam": {
        if (activityName === "Mobile Health - Bundle V/ROS Exam & TB Assessment") {
          returnData = MobileHealthBundle({ ...this.props });
        } else if (activityName === "Mobile Health - TB Assessment") {
          returnData = MobileHealthTB({ ...this.props }, "ProviderExam");
        } else if (activityName === "Mobile Health - V/ROS Exam") {
          returnData = MobileHealthVROS({ ...this.props }, "ProviderExam");
        } else if (activityName === "Exam - Fit for Duty") {
          returnData = ExamFitForDuty({ ...this.props, employmenStatusOption });
        } else {
          returnData = NonDOTExamBPVisionAudio1(
            {
              ...this.props,
              employmenStatusOption,
              onSaveAndSubmit: () => { this.onSaveAndSubmitHandler(); },
            },
            "ProviderExam"
          );
        }
      
        break;
      }      
      case "Respirator Fit Test":
        returnData  = RespiratorFitTest({...this.props});
        break;
      case "Lab":
      case "Lab - Point of Care":
        //changed Laboratory to LaboratoryNew 
          returnData  = LaboratoryNew({...this.props,reasonForLabs:this.state.reasonForLabs,fetchLabOrderList:this.fetchLabOrderList,fetchIcd10List:this.fetchIcd10List  });
          // returnData  = Laboratory({...this.props,reasonForLabs:this.state.reasonForLabs,fetchLabOrderList:this.fetchLabOrderList,fetchIcd10List:this.fetchIcd10List  });
          break;
      case "Vaccine":
        // returnData=Vaccination({...this.props});
         returnData= await NewVaccination({...this.props});
        break;
      case "Medication - Injectable":
        returnData=await Injection({...this.props});
        break;
      case "Medication - Dispensed":
        returnData=await DispensedRx({...this.props});
        break;
      case "Vital Signs":
        returnData=VitalSigns({...this.props});
        break;
      case "Audiogram":
        returnData=Audiogram({...this.props});
        break;
      case "EKG":
        returnData=EKG({...this.props});
        break;
      case "DME":
        returnData=DMEScreen({ ...this.props });
        break;
      default:
        returnData=DefaultScreen({...this.props})
        // returnData = {charts:[{type:'Label',value:'Upcoming Development'}],defaultValue:{}};
    }
    const {charts,headerContent,headers,buttons,defaultValue,computationFunction=async ()=>{return {};}} = returnData;
    // console.log('defaultValue',defaultValue,Object.entries(this.props.formData));
    this.setState({ charts:charts,headers:headers,headerContent:headerContent,buttons:isSet(buttons,{}),computationFunction:computationFunction });
    if(this.props.status===200){
      if(Object.entries(this.props.formData).length===0){
        this.props.setFormData(defaultValue);
      } else {
        const missingDefaults = {};
        Object.keys(defaultValue).forEach(key => {
          const existingValue = this.props.formData[key];
          const isValueMissing = existingValue === undefined || existingValue === null || existingValue === '';
          if (isValueMissing && defaultValue[key] !== undefined) {
            missingDefaults[key] = defaultValue[key];
          }
        });
       if (Object.keys(missingDefaults).length > 0) {
          this.props.setFormData({ ...this.props.formData, ...missingDefaults });
        }
      }
    }
   
  }
  fetchEmplymentStatusOptions = async (clinicId) => {
    let optionObj = {default:[{label: 'Select All', value: 'ALL'}]};
    try{
        const data = await ClinicService.getdropdownEmploymentStatusOptions(clinicId);
        
        if(!data) return optionObj;
        Object.entries(data).forEach(([key, value]) => {
            // Split values if comma separated
            const values = value.includes(",") ? value.split(",") : [value];

            optionObj[key] = values.map((item, index) => ({
                label: item.trim(),
                value: item.trim(),
                key: index
            }));            
        });
    } catch (e) {

    }
    return optionObj;
  }
  fetchIcd10List=async(term, callback = () => {})=>{
    
    try{
      const queryString = toQueryString({
        page: 1,
        perPage: 25,
        totalRecords: 0,
        sort_by: "code",
        sort_order: "asc",
        search: {
          search_query:term
        },
      });
      //  Loader(true);
       const response = await Icd10Service.getIcdList(queryString);
       if(response && response?.data.data){
          const options=response?.data.data.map((val)=>({
            label:`${val.code} - ${convertUnderScoreStrings(val.description)}`,
            value:val.icd10_id
          }))
     

          this.setState({ reasonForLabs: options });
          callback(options)
       }
       
    }catch(err){

    }finally{
        // Loader(false)
    }
  }

  // fetchReasonForLabList = async () => {
  //   let lookupOptions = [];
  //   try {
  //     const data = await LookupService.getLookupByKey(REASON_FOR_LAB)
  //     data.forEach((item) => {
  //       lookupOptions.push({
  //         label: item.value,
  //         value: item.value
  //       });
  //     });
  
      
  //   } catch (e) {
  //     //catch execption if need
  //     console.error('error in getLookupByKey', e);
      
  //   }
  //   this.setState({reasonForLabs:lookupOptions}) ;
  // }

  sendQuestionnaireHandler=(bool)=>{
    this.setState({isSendQuestionnaireOpen:bool});
  }

  
fetchLabOrderList = (val,prop,callback=()=>{})=>{
  //{search_query:val}
  const {formData,mappingId,updateFormData} = this.props;
  const mapping_id = formData?.mapping_id ?? mappingId;
  let optionArr =[];
  LabOrderdService.getLabOrder(null,formData?.lab_id,mapping_id)
  .then((res) => {
    // API returns paginated shape { data: [...], current_page, ... }; support both array and paginated response
    const list = Array.isArray(res) ? res : (res?.data ?? []);
    list.forEach((item, itemIndex) => {
      optionArr.push({
        label: item.lab_order,
        value: item.lab_order_id,
        data: item,
        index: itemIndex
      });
    });
    callback(optionArr);
    if (optionArr.length === 1 && updateFormData) {
      updateFormData({ lab_order_id: optionArr[0].value });
    }
  })
  .catch((error) => {
    console.error(error);
  });
  return optionArr;
}
documentModalHandler=()=>{
  this.setState({isDocumentModalOpen:!this.state.isDocumentModalOpen});
}


  render() {
    const {
      isDocumentModalOpen,
      isSendQuestionnaireOpen,
      charts,
      buttons,
      headers,
      computationFunction,
      showSendLabResultsModal,
      sendLabResultsOptions,
      sendTaskModalOpen,
      sendTaskModalInitialTaskTitle,
      sendTaskModalInitialMessage,
      sendTaskModalNavigationLink,
      isPatientPopoverOpen,
      isCompanyPopoverOpen,
    } = this.state;
    const {activityName,type,hasEditAccess} = this.props;    
    const isDotProviderExam =
      (activityName === "Examination - DOT" || activityName === "Exam - DOT - Department Of Transportation") &&
      type === "Provider Exam";
    const forceCollapsedForPatientDot = isDotProviderExam && !hasEditAccess;
    const isLeftSidebarCollapsedEffective = forceCollapsedForPatientDot ? true : this.state.isLeftSidebarCollapsed;
    const isDesktopLarge = (() => {
      try {
        return window.matchMedia?.("(min-width: 1025px)")?.matches ?? false;
      } catch (e) {
        return false;
      }
    })();
    const isTablet = this.isTabletWidth();
    const showModalSidebarToggle = this.state.charts.some((c) => c?.type === "Grid") && this.state.charts.some((c) => c?.type === "Tab");
    const isDotSchedulerLocked = this.isDotSchedulerLocked();
    const patientName = `${this.props.employeeDetails?.first_name || ""} ${this.props.employeeDetails?.last_name || ""}`.trim();
    const patientDob = this.props.employeeDetails?.dob || "";
    const patientId = this.props.employeeDetails?.patient_id || "";
    const patientPhone = this.props.employeeDetails?.phone ? formatPhoneNumberUS(this.props.employeeDetails.phone) : "";
    const patientEmployeeId = this.props.employeeId || this.props.employeeDetails?.employee_id || this.props.employeeDetails?.id;
    const fetchEmployeeDetailsHandler = this.props.fetchEmployeeDetails || (() => {});
    console.log("Employee IDDDDDD",this.props.employeeId);
    return (
        
         isSendQuestionnaireOpen ?  <SendQuestionnairePopup mappingId={this.props.mappingId} visitDetails={this.props.visitDetails}  isOpen={isSendQuestionnaireOpen} sendQuestionnaireHandler={this.sendQuestionnaireHandler}/>:

        isDocumentModalOpen ?
          <AddDocumentModal
            addFormHandler={this.documentModalHandler}
            mappingId={this.props.mappingId}
            activityId={this.props.activityId}
            visitDetails={this.props.visitDetails}
          />
         :
        <>
        <Modal
              show={true}
              onHide={this.props.toogleHanlder}
              size="xl"
              dialogClassName="hResponsive dotFullScreen"
              contentClassName="h-100"
              backdrop="static"
              keyboard={false}
              autoFocus={false} >
              <div className="sh_modalBox">
              <Modal.Header closeButton={this.props.hasEditAccess} className="flex-md-nowrap flex-wrap">
                  <Modal.Title>
                    <div className="d-flex align-items-center justify-content-center">
                      <h6 className="text-lg mb-0 font-weight-bold">
                        {activityName} - ({type})
                      </h6>
                    </div>
                  </Modal.Title>
                  {isSet(headers, []).map((header, headerIndex) => {
                    return (
                      <Wrap key={headerIndex}>
                        {header.type === "Tab" ? (
                          <div className="tabs-wrapper">
                            <ul className="nav nav-borders nav-tabs border-0">
                            {header.data
                              .filter(tab => !(tab.id === "provider" && !hasEditAccess))
                              .map((tab, tabIndex) => {
                                const isActive = tabIndex === 0 ? "active" : "";
                                return (
                                  tab && (
                                    <li key={tabIndex}>
                                      <a
                                        data-bs-toggle="tab"
                                        href={`#${tab.id}`}
                                        className={`nav-link cursor_pointer ${isActive}`}
                                        aria-selected="true"
                                        role="tab"
                                        onClick={() => this.handleTabClick(tab.id)}
                                      >
                                        {tab.label}
                                      </a>
                                    </li>
                                  )
                                );
                              })}
                            
                            </ul>
                          </div>
                        ) : null}
                      </Wrap>
                    );
                  })}
                  
                  </Modal.Header>
                  <Modal.Body className="pt-0">
                  {isTablet ? (
                    <div className="sh_visitStickyPatientBar pt-3 mb-2">
                      <div className="sh_visitStickyPatientBarLeft">
                        <span className="sh_visitStickyPatientAvatar" aria-hidden="true">
                          <svg width="24" height="24" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.8001 16.7996C15.2601 16.7996 13.9418 16.2513 12.8451 15.1546C11.7484 14.0579 11.2001 12.7396 11.2001 11.1996C11.2001 9.65961 11.7484 8.34128 12.8451 7.24461C13.9418 6.14794 15.2601 5.59961 16.8001 5.59961C18.3401 5.59961 19.6584 6.14794 20.7551 7.24461C21.8518 8.34128 22.4001 9.65961 22.4001 11.1996C22.4001 12.7396 21.8518 14.0579 20.7551 15.1546C19.6584 16.2513 18.3401 16.7996 16.8001 16.7996ZM8.4001 27.9996C7.6301 27.9996 6.97116 27.7257 6.4233 27.1778C5.8745 26.629 5.6001 25.9696 5.6001 25.1996V24.0796C5.6001 23.2863 5.8045 22.5569 6.2133 21.8914C6.62116 21.2269 7.16343 20.7196 7.8401 20.3696C9.28676 19.6463 10.7568 19.1035 12.2501 18.7414C13.7434 18.3802 15.2601 18.1996 16.8001 18.1996C18.3401 18.1996 19.8568 18.3802 21.3501 18.7414C22.8434 19.1035 24.3134 19.6463 25.7601 20.3696C26.4368 20.7196 26.979 21.2269 27.3869 21.8914C27.7957 22.5569 28.0001 23.2863 28.0001 24.0796V25.1996C28.0001 25.9696 27.7262 26.629 27.1783 27.1778C26.6295 27.7257 25.9701 27.9996 25.2001 27.9996H8.4001ZM8.4001 25.1996H25.2001V24.0796C25.2001 23.8229 25.1362 23.5896 25.0083 23.3796C24.8795 23.1696 24.7101 23.0063 24.5001 22.8896C23.2401 22.2596 21.9684 21.7869 20.6851 21.4714C19.4018 21.1569 18.1068 20.9996 16.8001 20.9996C15.4934 20.9996 14.1984 21.1569 12.9151 21.4714C11.6318 21.7869 10.3601 22.2596 9.1001 22.8896C8.8901 23.0063 8.72116 23.1696 8.5933 23.3796C8.4645 23.5896 8.4001 23.8229 8.4001 24.0796V25.1996ZM16.8001 13.9996C17.5701 13.9996 18.2295 13.7252 18.7783 13.1764C19.3262 12.6285 19.6001 11.9696 19.6001 11.1996C19.6001 10.4296 19.3262 9.77068 18.7783 9.22281C18.2295 8.67401 17.5701 8.39961 16.8001 8.39961C16.0301 8.39961 15.3712 8.67401 14.8233 9.22281C14.2745 9.77068 14.0001 10.4296 14.0001 11.1996C14.0001 11.9696 14.2745 12.6285 14.8233 13.1764C15.3712 13.7252 16.0301 13.9996 16.8001 13.9996Z" fill="#4A505C"></path></svg>
                        </span>
                        <div className="sh_visitStickyPatientText">
                          <span className="sh_visitStickyPatientName">{patientName}</span>
                          <span className="sh_visitStickyPatientMeta">
                            {patientDob ? `DOB: ${patientDob}` : ""}
                            {patientId ? `  |  ID: ${patientId}` : ""}
                            {patientPhone ? `  |  Phone: ${patientPhone}` : ""}
                          </span>
                        </div>
                      </div>
                      <div className="sh_visitStickyPatientBarRight">
                        <button
                          ref={this.patientBtnRef}
                          type="button"
                          className="btn btn-primary"
                          onClick={() =>
                            this.setState((prev) => ({
                              isPatientPopoverOpen: !prev.isPatientPopoverOpen,
                              isCompanyPopoverOpen: false,
                            }))
                          }
                        >
                          Patient
                        </button>
                        <button
                          ref={this.companyBtnRef}
                          type="button"
                          className="btn btn-primary ml-2"
                          onClick={() =>
                            this.setState((prev) => ({
                              isCompanyPopoverOpen: !prev.isCompanyPopoverOpen,
                              isPatientPopoverOpen: false,
                            }))
                          }
                        >
                          Company
                        </button>
                      </div>
                      <div
                        ref={this.patientPopoverRef}
                        className={`sh_visitStickyPopover ${isPatientPopoverOpen ? "open" : ""}`}
                        style={{ left: 0 }}
                      >
                        <div className="sh_visitStickyPopoverInner">
                          <NewPatientDetails
                            visit_id={this.props.mappingId}
                            employeeId={patientEmployeeId}
                            employeeDetails={this.props.employeeDetails}
                            fetchEmployeeDetails={fetchEmployeeDetailsHandler}
                          />
                        </div>
                      </div>
                      <div
                        ref={this.companyPopoverRef}
                        className={`sh_visitStickyPopover ${isCompanyPopoverOpen ? "open" : ""}`}
                        style={{ left: "auto" }}
                      >
                        <div className="sh_visitStickyPopoverInner">
                          <NewCompanyDetails companyDetails={this.props.visitDetails?.company} />
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <div className="h-100 row sh_emrSidebarRowWrap"> 
                  {showModalSidebarToggle && isDesktopLarge && !forceCollapsedForPatientDot ? (
                    <button
                      type="button"
                      className={`btn sh_btniconnew sh_emrSidebarEdgebtnToggle ${isLeftSidebarCollapsedEffective ? "is-collapsed" : ""}`}
                      onClick={() => this.setState((prev) => ({ isLeftSidebarCollapsed: !prev.isLeftSidebarCollapsed }))}
                      title={isLeftSidebarCollapsedEffective ? "Expand sidebar" : "Collapse sidebar"}
                      aria-label={isLeftSidebarCollapsedEffective ? "Expand left sidebar" : "Collapse left sidebar"}
                    >
                      {isLeftSidebarCollapsedEffective ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          width="16px"
                          height="16px"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5"
                          />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          width="16px"
                          height="16px"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5"
                          />
                        </svg>
                      )}
                    </button>
                  ) : null}
                  {charts.map((chart, chartIndex) => {
                    if (!chart) return null;
                    const { col, type, data, style, className } = chart;
                    const isGridSidebar = type === "Grid" && showModalSidebarToggle;
                    const updatedCol =
                      showModalSidebarToggle && isLeftSidebarCollapsedEffective && type === "Tab"
                        ? "col-md-12"
                        : col;
                    return (
                      <div
                        className={`${updatedCol} col-12 ${
                          isGridSidebar ? `sh_visitLeftSidebarCol ${isLeftSidebarCollapsedEffective ? "is-collapsed" : ""}` : ""
                        }`}
                        key={chartIndex}
                      >
                          {type === "Grid" ? (
                            this.props.hasEditAccess ? (
                              <>
                                {className && (
                                  <style>{`
                                    .${className}::-webkit-scrollbar {
                                      width: 4px;
                                    }
                                    .${className}::-webkit-scrollbar-track {
                                      background: transparent;
                                    }
                                    .${className}::-webkit-scrollbar-thumb {
                                      background: #c1c1c1;
                                      border-radius: 10px;
                                    }
                                    .${className}::-webkit-scrollbar-thumb:hover {
                                      background: #a8a8a8;
                                    }
                                  `}</style>
                                )}
                                <div 
                                  className={className || ''}
                                  style={style || { position: "sticky", top: "0", zIndex: "1"}}
                                >
                                  {data.map((grid, gridIndex) => (
                                    <ChartsFields
                                      key={gridIndex}
                                      item={grid}
                                      formData={this.props.formData}
                                      onSubmitHandler={"on"}
                                      employeeId={this.props.employeeId}
                                      fetchEmployeeDetails={this.props.fetchEmployeeDetails}
                                      
                                    />
                                  ))}
                                </div>
                              </>
                            ) : null
                          ) : type === 'SectionBased' ? (
                          <>
                            {data.map((secData, secIndex) => (
                              <SectionBasedDetails
                                key={secIndex}
                                {...secData}
                                readOnly={!hasEditAccess}
                                formData={this.props.formData}
                                validation={this.props.validation}
                                changeHandler={async (key,val,obj)=>{
                                  const computedData = await computationFunction({...this.props.formData,[key]:val},key);
                                  this.props.changeHandler(key,val,{...obj,...computedData})
                                }}
                                updateFormData={async (obj)=>{
                                  const computedData = await computationFunction({...this.props.formData,...obj});
                                  this.props.updateFormData({...obj,...computedData})
                                }
                              }
                                Toast={this.props.Toast}
                                Loader={this.props.Loader}
                                activityId={this.props.activityId}
                              />
                            ))}
                          </>
                        ): type === 'Tab' ? (
                     <div className="s">
                      {(
                        this.props.type === "Vaccine" ||
                        this.props.type === "TB Blood Draw" ||
                        this.props.type === "TB Skin Test" ||
                        this.props.type === "Xray" ||
                        this.props.type === "Non DOT Exam - BP / Vision / Audio" ||
                        this.props.type === "Minimal Exam" || 
                        this.props.type === "Pulmonary Function Test" ||
                        this.props.type === "Exam - Non DOT - Hearing Audio" ||
                        this.props.type === "Audiogram" ||
                        this.props.type === "EKG" ||
                         this.props.type === "Vision Screen" ||
                         this.props.type === "Exam - Fit For Duty" ||
                        // this.props.type === "Vital Signs" ||
                        this.props.type === "Lab" ||
                        this.props.type === "Lab - Point of Care" ||
                        this.props.type === "Medication - Dispensed" ||
                        this.props.type === "Drug Screen Collection" ||
                        this.props.type === "Drug Screen - 13 Panel" ||
                        this.props.type === "Drug Screen - 12 Panel" ||
                        this.props.type === "Drug Screen - 11 Panel" ||
                        this.props.type === "Drug Screen - 10 Panel" ||
                        this.props.type === "Drug Screen - 10 Panel (AH)" ||
                        this.props.type === "Drug Screen - 9 Panel" ||
                        this.props.type === "Drug Screen - 7 Panel" ||
                        this.props.type === "Drug Screen - 5 Panel" ||
                        this.props.type === "Drug Screen - 4 Panel" ||
                        this.props.type === "Drug Screen - EZ-Reader" ||
                        this.props.type === "Medication - Injectable" ||
                        (this.props.type === "Provider Exam" && 
                         this.props.activityName !== "Mobile Health - Bundle V/ROS Exam & TB Assessment" &&
                         this.props.activityName !== "Mobile Health - TB Assessment" &&
                         this.props.activityName !== "Mobile Health - V/ROS Exam")) && (
                         <ul className="nav sh_subnav mb-3 px-4 w-100 d-flex flex-wrap align-items-center" role="tablist">
                           {data
                              .filter((tabData) => (hasEditAccess ? true : tabData.id === "patient"))
                              .map((tabData, tabIndex) => {
                              const dotTabUnlocked = this.props.formData?.dot_submission_ready || this.state.submissionJustPassed;
                              const isDisabled = tabData.id === 'dot_submission' && !dotTabUnlocked;
                              const activeTabIdExists = data.some((t) => t.id === this.state.activeTabId);
                              const isActive = (this.state.activeTabId && activeTabIdExists && tabData.id === this.state.activeTabId) || ((!this.state.activeTabId || !activeTabIdExists) && tabIndex === 0);
                              return (
                              <li className="nav-item" key={tabIndex}>
                              <a
                               style={{ fontSize: "12px", whiteSpace: "nowrap", ...(isDisabled ? { pointerEvents: 'none', opacity: 0.6 } : {}) }}
                               className={`nav-link text-dark ${isActive ? "active" : ""} ${isDisabled ? "disabled" : ""}`}
                               id={`${tabData.id}-tab`}
                               data-bs-toggle={isDisabled ? null : "tab"}
                               href={isDisabled ? "#" : `#${tabData.id}`}
                               role="tab"
                               aria-controls={tabData.id}
                               aria-selected={isActive}
                               aria-disabled={isDisabled}
                               onClick={(e) => { if (isDisabled) e.preventDefault(); else this.handleTabClick(tabData.id); }}
                              >
                             {tabData.label}
                          </a>
                        </li>
                     );})}
                    <li className="nav-item ml-auto py-1">
                      {isSet(buttons.showLabTopActions, false) === true ? (
                        <div className="d-flex align-items-center">
                          <div className="dropdown mr-2">
                            <button
                              type="button"
                              className="btn shadow-sm border-0 sh_btniconnew scalable dropdown-toggle"
                              title="Print Lab and Requisition Report"
                              data-bs-toggle="dropdown"
                            >
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.66675 5.33333V2.66667C4.66675 2.29867 4.96541 2 5.33341 2H10.6667C11.0347 2 11.3334 2.29867 11.3334 2.66667V5.33333" stroke="#1D1917" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.66667 11.333H3.33333C2.59667 11.333 2 10.7363 2 9.99967V6.66634C2 5.92967 2.59667 5.33301 3.33333 5.33301H12.6667C13.4033 5.33301 14 5.92967 14 6.66634V9.99967C14 10.7363 13.4033 11.333 12.6667 11.333H11.3333" stroke="#1D1917" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path fillRule="evenodd" clipRule="evenodd" d="M4.66675 9.2002H11.3334V13.3335C11.3334 13.7015 11.0347 14.0002 10.6667 14.0002H5.33341C4.96541 14.0002 4.66675 13.7015 4.66675 13.3335V9.2002Z" stroke="#1D1917" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.66675 7.33333H5.33341" stroke="#1D1917" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              </svg>
                            </button>
                            <div className="dropdown-menu dropdown-menu-right shadow">
                              <button
                                className="dropdown-item"
                                type="button"
                                onClick={() => this.props.printResultHandler("Lab_Report")}
                              >
                                Lab Report
                              </button>
                              <button
                                className="dropdown-item"
                                type="button"
                                onClick={() => this.props.printResultHandler("Lab_Requisition")}
                              >
                                Lab Requisition
                              </button>
                            </div>
                          </div>
                          <div className="dropdown mr-2">
                            <button
                              type="button"
                              className="btn shadow-sm border-0 sh_btniconnew scalable dropdown-toggle"
                              title="Print Lab Label"
                              data-bs-toggle="dropdown"
                            >
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.6667 6H12.6667C13.403 6 14 6.59695 14 7.33333V12.6667C14 13.403 13.403 14 12.6667 14H3.33333C2.59695 14 2 13.403 2 12.6667V7.33333C2 6.59695 2.59695 6 3.33333 6H4.33333" stroke="#1D1917" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <rect x="4.33325" y="2.66699" width="7.33333" height="6" rx="1" stroke="#1D1917" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M11.3334 11.3333H4.66675" stroke="#1D1917" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              </svg>
                            </button>
                            <div className="dropdown-menu dropdown-menu-right shadow" aria-labelledby="userDropdown">
                              <div className="dropdown-item pointer" href="#" onClick={(e) => {
                                e.preventDefault();
                                this.props.printLabelHandler("print_label_2x3", "2 x 3.8");
                              }}>
                                Print Lab Label 2 X 3.8
                              </div>
                              <div className="dropdown-item pointer" href="#" onClick={(e) => {
                                e.preventDefault();
                                this.props.printLabelHandler("print_label_1x3", "1⅛ x 3½");
                              }}>
                                Print Lab Label 1 ⅛ X 3 ½
                              </div>
                            </div>
                          </div>
                          <button
                            type="button"
                            className="btn shadow-sm border-0 sh_btniconnew scalable"
                            title="Send Results"
                            onClick={this.openSendLabResultsModal}
                          >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fillRule="evenodd" clipRule="evenodd" d="M2 4.53301V4.53301C2 4.93301 2.2 5.26634 2.53333 5.53301L6.53333 8.26634C7.46667 8.86634 8.6 8.86634 9.53333 8.26634L13.5333 5.59967C13.8 5.26634 14 4.93301 14 4.53301V4.53301C14 3.86634 13.4667 3.33301 12.8 3.33301H3.2C2.53333 3.33301 2 3.86634 2 4.53301Z" stroke="#323232" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M2 4.66699V11.3337C2 12.067 2.6 12.667 3.33333 12.667H12.6667C13.4 12.667 14 12.067 14 11.3337V4.66699" stroke="#323232" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M2.39209 12.2746L6.45476 8.21191" stroke="#323232" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M9.57324 8.24023L13.6079 12.2749" stroke="#323232" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </button>
                        </div>
                      ) : isSet(buttons.showDrugScreenPrintActions, false) === true ? (
                        <div className="d-flex align-items-center">
                          <div className="dropdown mr-2">
                            <button
                              type="button"
                              className="btn shadow-sm border-0 sh_btniconnew scalable dropdown-toggle"
                              title="Print drug screen label"
                              data-bs-toggle="dropdown"
                            >
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.6667 6H12.6667C13.403 6 14 6.59695 14 7.33333V12.6667C14 13.403 13.403 14 12.6667 14H3.33333C2.59695 14 2 13.403 2 12.6667V7.33333C2 6.59695 2.59695 6 3.33333 6H4.33333" stroke="#1D1917" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <rect x="4.33325" y="2.66699" width="7.33333" height="6" rx="1" stroke="#1D1917" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M11.3334 11.3333H4.66675" stroke="#1D1917" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              </svg>
                            </button>
                            <div className="dropdown-menu dropdown-menu-right shadow">
                              <button
                                className="dropdown-item"
                                type="button"
                                onClick={() => this.props.printLabelHandler("print_label_2x3", "Drug screen label 2 x 3.8")}
                              >
                                Print Drug Screen Label 2 X 3.8
                              </button>
                              <button
                                className="dropdown-item"
                                type="button"
                                onClick={() => this.props.printLabelHandler("print_label_1x3", "Drug screen label 1⅛ x 3½")}
                              >
                                Print Drug Screen Label 1 ⅛ X 3 ½
                              </button>
                            </div>
                          </div>
                          <button
                            type="button"
                            className="btn shadow-sm border-0 sh_btniconnew scalable"
                            title="Print drug screen result"
                            onClick={() => this.props.printResultHandler()}
                          >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4.66675 5.33333V2.66667C4.66675 2.29867 4.96541 2 5.33341 2H10.6667C11.0347 2 11.3334 2.29867 11.3334 2.66667V5.33333" stroke="#1D1917" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M4.66667 11.333H3.33333C2.59667 11.333 2 10.7363 2 9.99967V6.66634C2 5.92967 2.59667 5.33301 3.33333 5.33301H12.6667C13.4033 5.33301 14 5.92967 14 6.66634V9.99967C14 10.7363 13.4033 11.333 12.6667 11.333H11.3333" stroke="#1D1917" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path fillRule="evenodd" clipRule="evenodd" d="M4.66675 9.2002H11.3334V13.3335C11.3334 13.7015 11.0347 14.0002 10.6667 14.0002H5.33341C4.96541 14.0002 4.66675 13.7015 4.66675 13.3335V9.2002Z" stroke="#1D1917" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M4.66675 7.33333H5.33341" stroke="#1D1917" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </button>
                        </div>
                      ) : 
                      // isSet(buttons.showTopUpdateButton, true) === true ? (
                      //   <Buttons
                      //     clickHandler={() => this.props.onSubmitHandler()}
                      //     className="btn px-3 btn-primary"
                      //     acl={this.props.profile.role === "company_employee"? [PERMISSIONS.APPOINTMENT.CREATE] : [PERMISSIONS.RESULT.EDIT, PERMISSIONS.VISITS.EDIT]}
                      //     label={"Update"}
                      //     title={"Update"}
                      //   />
                      // ) 
                      null}
                    </li>
                    </ul>
                      )}
   
                      <div className="tab-content">
                        {data
                          .filter(tabData => hasEditAccess ? true : tabData.id === "patient" || tabData.id === "history" || tabData.id === "Images")
                          .map((tabData, tabIndex) => (
                            <div
                              id={isSet(tabData.id, '')}
                              key={tabIndex}
                              className={`tab-pane fade ${((this.state.activeTabId && data.some((t) => t.id === this.state.activeTabId) && this.state.activeTabId === tabData.id) || ((!this.state.activeTabId || !data.some((t) => t.id === this.state.activeTabId)) && tabIndex === 0)) ? "show active" : ""}`}
                              role="tabpanel"
                              aria-labelledby={`${tabData.id}-tab`}
                            >
                              {tabData.id === "patient" || tabData.id === "history" ? (
                                <>
                                  {!this.props.suppressPatientPostSaveLogout && (
                                    <Acl acl="visits-edit">
                                      <Button
                                        acl="visits-edit"
                                        clickHandler={() => { this.sendQuestionnaireHandler(true) }}
                                        className="btn btn-secondary"
                                      >
                                        Send Questionnaire
                                      </Button>
                                      <br /><br />
                                    </Acl>
                                  )}
                                </>
                              ) : null}
                      
                              {tabData.id === "Images" ? (
                                <ImagesList
                                  mappingId={this.props.mappingId}
                                  Toast={this.props.Toast}
                                  Loader={this.props.Loader}
                                />
                              ) : tabData.id === "dot_submission" ? (
                                <DotSubmissionPage
                                  loading={this.state.dotValidationLoading}
                                  validation={this.state.dotValidation}
                                  schedulerStatus={this.state.dotSchedulerStatus}
                                  eventLogs={this.state.dotEventLogs}
                                  openSubmitModalAfterSave={this.state.openSubmitToDotModalAfterSave}
                                  onSubmitModalOpened={() => this.setState({ openSubmitToDotModalAfterSave: false, submissionJustPassed: false })}
                                  onSubTabChange={(tab) => {
                                    // Fetch logs when FMCSA Response tab is clicked
                                    if (tab === 'fmcsa-response') {
                                      this.fetchDotEventLogs();
                                    }
                                  }}
                                  onValidateClick={this.handleDotNightlySubmission}
                                  onSubmitNowClick={this.handleDotSubmitNowSelection}
                                />
                              ) : (
                                isSet(tabData.data, []).map((secData, secIndex) => (
                                  <div id={isSet(secData.id, '')} key={secIndex}>
                                    <SectionBasedDetails
                                      {...secData}
                                      // readOnly={
                                      //   tabData.id === "provider"
                                      //     ? !hasEditAccess
                                      //     : tabData.id === "patient"
                                      //       ? !hasEditAccess
                                      //       : true
                                      // }
                                      key={secIndex}
                                      readOnly={!(tabData.id === 'patient' || tabData.id === 'history') && !hasEditAccess}
                                      formData={this.props.formData}
                                      // displayValue={this.props.formData.reason_for_lab_label||""}
                                      changeHandler={async (key,val,obj)=>{
                                        const computedData = await computationFunction({...this.props.formData,[key]:val},key);
                                        this.props.changeHandler(
                                          key,
                                          val,
                                          {...obj, ...computedData}
                                        )
                                      }}
                                      updateFormData={async (obj)=>{
                                        const computedData = await computationFunction({...this.props.formData,...obj});
                                        this.props.updateFormData(
                                          {...obj, ...computedData}
                                        )
                                      }}
                                      Toast={this.props.Toast}
                                      Loader={this.props.Loader}
                                      activityId={this.props.activityId}
                                      sendMessageClickHandler={
                                        this.isPatientQuestionnaireContext()
                                          ? undefined
                                          : this.openSendTaskModalFromLab
                                      }
                                    />
                                  </div>
                                ))
                              )}
                            </div>
                          ))}
                      </div>
                       </div>
                        ):type==='Label'?
                          <label title={isSet(chart.value,'')}>{isSet(chart.value,'')}</label>:
                      ''}
                      </div>
                    );
                  })}
                </div>
                  </Modal.Body>
                  <Modal.Footer className="d-flex justify-content-between">
                  <div class="addAction ml-2">
                    {(isSet(buttons.label,false)===true &&
                      isSet(buttons.showDrugScreenPrintActions, false) !== true) ?
                       <div className="btn-group mr-1">
                       <a className="btn btn-xs btn-secondary ">
                         <i className="fas fa-print fa-sm"></i> Label
                       </a>
                       <button
                         className="btn btn-xs  btn-outline-secondary dropdown no-arrow"
                         data-bs-toggle="dropdown"
                         aria-expanded="false" >
                         <span className="dropdown-toggle">
                           <i className="fas fa-ellipsis-v fa-sm fa-fw text-gray-400"></i>
                         </span>
                         <div
                           className="dropdown-menu dropdown-menu-right shadow"
                           aria-labelledby="userDropdown"
                         >
                           <a
                             className="dropdown-item"
                             href="!#"
                             onClick={() =>
                               this.props.printLabelHandler(
                                 "print_label_2x3",
                                 "2 x 3.8"
                               )
                             }
                           >
                             2 x 3.8
                           </a>
                           <a
                             className="dropdown-item"
                             href="!#"
                             onClick={() =>
                               this.props.printLabelHandler(
                                 "print_label_1x3",
                                 "1⅛ x 3½"
                               )
                             }
                           >
                             1⅛ x 3½
                           </a>
                         </div>
                       </button>
                     </div>
                    :<></>}


                    {isSet(buttons.PDF, false) === true && this.props.hasEditAccess?
                       <div className="btn-group mr-1">
                       <a className="btn btn-xs btn-secondary ">
                         <i className="fas fa-print fa-sm"></i><span className="d-md-inline d-none">Print Pdf </span> 
                       </a>
                       <button
                         className="btn btn-xs  btn-outline-secondary dropdown no-arrow"
                         data-bs-toggle="dropdown"
                         aria-expanded="false" >
                         <span className="dropdown-toggle">
                           <i className="fas fa-ellipsis-v fa-sm fa-fw text-gray-400"></i>
                         </span>
                         <div
                           className="dropdown-menu dropdown-menu-right shadow"
                           aria-labelledby="userDropdown" >
                           <a
                             className="dropdown-item"
                             href="!#"
                             onClick={() => this.props.printResultHandler('Provider')}>
                             Provider
                           </a>
                           <a
                             className="dropdown-item"
                             href="!#"
                             onClick={() => this.props.printResultHandler('Patient')} >
                             Patient 
                           </a> 
                         </div>
                       </button>
                     </div>
                    :<></>}
                   
                   {(isSet(buttons.result,false)===true &&
                     isSet(buttons.showDrugScreenPrintActions, false) !== true) ? (
                      <a
                        class="btn btn-xs  btn-secondary mr-1"
                        onClick={() => this.props.printResultHandler()}>
                        {" "}
                        <i className="fas fa-print fa-sm"></i> Result
                      </a>
                    ) : (
                      <></>
                    )}
                      {(isSet(buttons.labreport,false)===true)? (
                      <a
                        class="btn btn-xs  btn-secondary mr-1"
                        onClick={() => this.props.printResultHandler("Lab_Report")}>
                        {" "}
                        <i className="fas fa-print fa-sm"></i>Laboratory Report
                      </a>
                    ) : (
                      <></>
                    )}
                        {(isSet(buttons.labreport,false)===true)? (
                      <a
                        class="btn btn-xs  btn-secondary mr-1"
                        onClick={() => this.props.printResultHandler("Lab_Requisition")}>
                        {" "}
                        Print Lab Requisition
                      </a>
                    ) : (
                      <></>
                    )}
                  </div>
                <Acl acl={this.props.profile.role === 'company_employee' ? [PERMISSIONS.APPOINTMENT.CREATE] : [PERMISSIONS.RESULT.EDIT, PERMISSIONS.VISITS.EDIT]}>
                  <div className="p-2 d-flex justify-content-end gap-2 ">
                    {!this.isPatientQuestionnaireContext() && (
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={this.openSendTaskModalFromActivityChartToolbar}
                      title="Send a message"
                      aria-label="Send message from activity chart"
                      style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
                    >
                      <span className="d-inline-flex align-items-center" aria-hidden>
                        <PhoneIcon color="#FFFFFF" size={20} />
                      </span>
                      Message
                    </button>
                    )}
                    {this.props.hasEditAccess && (
                      <Buttons
                        clickHandler={() => this.documentModalHandler()}
                        className="btn sh_btnlight ml-2"
                        acl={"any"}
                        label={"Add Document"}
                        title={"Add Document"}
                      />
                    )}
                    <Buttons
                      clickHandler={() => {
                        const isDotProviderExam =
                          (this.props.activityName === "Examination - DOT" ||
                            this.props.activityName === "Exam - DOT - Department Of Transportation") &&
                          this.props.type === "Provider Exam";
                        /** Patient / questionnaire portal: close modal after Save Progress (matches Alert save-and-close). Staff keeps chart open. */
                        const closeAfterSaveProgress =
                          !!this.props.profileDetails?.employee_login ||
                          !!this.props.suppressPatientPostSaveLogout;
                        if (isDotProviderExam) {
                          this.props.onSubmitHandler(
                            undefined,
                            false,
                            closeAfterSaveProgress,
                            false,
                            true,
                            closeAfterSaveProgress
                          );
                        } else {
                          this.props.onSubmitHandler();
                        }
                      }}
                      className="btn btn-primary"
                      acl={this.props.profile.role === 'company_employee' ? [PERMISSIONS.APPOINTMENT.CREATE] : [PERMISSIONS.RESULT.EDIT, PERMISSIONS.VISITS.EDIT]}
                      label={
                        (this.props.activityName === "Examination - DOT" ||
                          this.props.activityName === "Exam - DOT - Department Of Transportation") &&
                        this.props.type === "Provider Exam"
                          ? "Save Progress"
                          : "Save"
                      }
                      title={
                        (this.props.activityName === "Examination - DOT" ||
                          this.props.activityName === "Exam - DOT - Department Of Transportation") &&
                        this.props.type === "Provider Exam"
                          ? "Save Progress"
                          : "Save"
                      }
                    />
                    {/* {((this.props.activityName === "Examination - DOT" || this.props.activityName === "Exam - DOT - Department Of Transportation") && this.props.type === "Provider Exam") && (
                    <Buttons
                      clickHandler={() => {
                        if (!isDotSchedulerLocked) {
                          this.onSaveAndSubmitHandler();
                        }
                      }}
                      className="btn btn-primary"
                      acl={this.props.profile.role === 'company_employee' ? [PERMISSIONS.APPOINTMENT.CREATE] : [PERMISSIONS.RESULT.EDIT, PERMISSIONS.VISITS.EDIT]}
                      label={"Save & Submit"}
                      title={"Save"}
                      disabled={isDotSchedulerLocked}
                      disableButtonTitle={"DOT scheduler status is pending/completed"}
                    />
                  )} */}
                  </div>
                </Acl>
                  
                </Modal.Footer>
                  </div>
            </Modal>

            {showSendLabResultsModal && (
              <Modal
                show={showSendLabResultsModal}
                onHide={this.closeSendLabResultsModal}
                dialogClassName="hResponsive"
                centered
                keyboard={false}
                backdrop="static"
              >
                <div className="sh_modalBox">
                  <Modal.Header closeButton>
                    <Modal.Title>
                      <h6 className="text-lg mb-0 font-weight-bold">Send Lab Results</h6>
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="mb-2" style={{ fontSize: "15px", color: "#4b5563" }}>
                      Choose where to send these lab results.
                    </div>
                    <div className="form-group">
                      <div className="form-check mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="sendLabResultPatient"
                          checked={sendLabResultsOptions.sendPatient}
                          onChange={() => this.handleToggleSendLabOption("sendPatient")}
                        />
                        <label className="form-check-label" htmlFor="sendLabResultPatient">
                          Send Patient
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="sendLabResultEmployer"
                          checked={sendLabResultsOptions.sendEmployer}
                          onChange={() => this.handleToggleSendLabOption("sendEmployer")}
                        />
                        <label className="form-check-label" htmlFor="sendLabResultEmployer">
                          Send Employer
                        </label>
                      </div>
                    </div>
                  </Modal.Body>
                  <Modal.Footer className="d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn btn-secondary sh_btnsecondary mr-2"
                      onClick={this.closeSendLabResultsModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary sh_btnprimary mr-2"
                      onClick={this.handleConfirmSendLabResults}
                    >
                      Continue
                    </button>
                  </Modal.Footer>
                </div>
              </Modal>
            )}
            {sendTaskModalOpen && (
              <SendTaskModal
                isOpen={sendTaskModalOpen}
                modalToogleHandler={this.closeSendTaskModal}
                Toast={this.props.Toast}
                Loader={this.props.Loader}
                navigationLink={sendTaskModalNavigationLink}
                initialTaskTitle={sendTaskModalInitialTaskTitle}
                initialMessageBody={sendTaskModalInitialMessage}
              />
            )}
            </>
      
    );
  }
}
export default withReduxState(ActivityChartsContent) ;
